import React from 'react';
import { FadeIn } from './FadeIn';
export function Guarantee() {
  return <section className="py-16 px-6 bg-cream" data-id="element-131">
      <div className="max-w-3xl mx-auto" data-id="element-132">
        <FadeIn data-id="element-133">
          <div className="bg-white p-8 md:p-12 rounded-3xl border-2 border-sage/30 shadow-lg text-center relative" data-id="element-134">
            <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-sage text-white w-16 h-16 rounded-full flex items-center justify-center text-3xl shadow-lg border-4 border-white" data-id="element-135">
              🛡️
            </div>

            <h2 className="text-3xl font-bold text-brown-dark mb-6 mt-4 font-serif" data-id="element-136">
              Su Garantía de Paz Mental
            </h2>

            <p className="text-xl text-brown mb-6 leading-relaxed" data-id="element-137">
              Si en 7 días no siente ningún cambio, le devolvemos cada centavo.
              Sin preguntas. Sin formularios complicados. Solo escríbanos.
            </p>

            <p className="text-2xl font-serif italic text-sage-dark font-medium" data-id="element-138">
              Usted no tiene nada que perder y su bienestar que ganar.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}